import { render } from "./Planos.vue?vue&type=template&id=4446105e&scoped=true&ts=true"
import script from "./Planos.vue?vue&type=script&lang=ts"
export * from "./Planos.vue?vue&type=script&lang=ts"

import "./Planos.vue?vue&type=style&index=0&id=4446105e&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4446105e"]])

export default __exports__